<div class="dialog-header">
  <h6>Payment Instruction</h6>
  <button mat-icon-button class="close-icon" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="email-dialog">
  <div class="email-section">
    <div class="email-fields">
      <div class="field-container">
        <div class="field-label" style="margin-right: 18px">
          <mat-label>To:</mat-label>
        </div>
        <div class="field-input">
          <mat-chip-grid #chipGrid>
            <mat-chip-row
              *ngFor="let email of selectedToEmails"
              (removed)="removeToEmail(email)"
            >
              {{ email }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
            <input
              type="text"
              placeholder="Add email"
              matInput
              [formControl]="to"
              [matAutocomplete]="autoTo"
              [matChipInputFor]="chipGrid"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addToEmail($event)"
            />
          </mat-chip-grid>
          <mat-autocomplete
            #autoTo="matAutocomplete"
            (optionSelected)="selectToEmail($event)"
          >
            <mat-option
              *ngFor="let option of filteredToOptions | async"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-autocomplete>
          <div class="validation-message" *ngIf="selectedToEmails.length === 0">
            At least one recipient is required
          </div>
        </div>
      </div>

      <div class="field-container">
        <div class="field-label" style="margin-right: 15px">
          <mat-label>CC:</mat-label>
        </div>
        <div class="field-input">
          <mat-chip-grid #chipGridCc>
            <mat-chip-row
              *ngFor="let email of selectedCcEmails"
              (removed)="removeCcEmail(email)"
            >
              {{ email }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
            <input
              type="text"
              placeholder="Add email"
              matInput
              [formControl]="cc"
              [matAutocomplete]="autoCc"
              [matChipInputFor]="chipGridCc"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addCcEmail($event)"
            />
          </mat-chip-grid>
          <mat-autocomplete
            #autoCc="matAutocomplete"
            (optionSelected)="selectCcEmail($event)"
          >
            <mat-option
              *ngFor="let option of filteredCcOptions | async"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
    </div>
  <div class="subject-field-container">
      <div class="subject-field-label">
        <mat-label>Subject:</mat-label>
      </div>
      <div class="subject-field-input">
        <input
          type="text"
          matInput
          [(ngModel)]="subject"
          class="subject-input"
          placeholder="Enter Subject"
        />
      </div>
    </div>
    <div class="body-field-container">
      <div class="body-field-label">
        <mat-label>Body:</mat-label>
      </div>
      <div class="body-field-input">
        <div class="email-body-container">
          <div
            contenteditable="true"
            class="email-content-editor"
            placeholder="Enter text above table..."
            #topTextDiv
          >
            {{ greetingText }}
          </div>
          <table class="email-table">
            <!-- MAIN DETAILS -->
            <tr *ngFor="let row of tableData">
              <td class="email-table-label">
                {{ row.label }}
              </td>

              <td
                contenteditable="true"
                class="email-table-value"
                (blur)="updateTableValue(row, $event)"
              >
                {{ row.value }}
              </td>
            </tr>

            <!-- Port Agent Office Address Row -->
            <tr *ngIf="portAgentOfficeAddress !== null && portAgentOfficeAddress !== undefined">
              <td class="email-table-label">Office Address</td>
              <td
                contenteditable="true"
                class="email-table-value"
                (blur)="updateOfficeAddress($event)"
              >
                {{ portAgentOfficeAddress }}
              </td>
            </tr>

            <!-- BANK DETAILS SECTION -->
            <ng-container *ngIf="bankDetailsData">
              <tr>
                <td colspan="2" class="bank-details-header">Bank Details</td>
              </tr>

              <!-- Account Holder -->
              <tr *ngIf="bankDetailsData.account_holder_name">
                <td class="email-table-label">Account Holder Name</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('account_holder_name', $event)"
                >
                  {{ bankDetailsData.account_holder_name }}
                </td>
              </tr>

              <!-- Bank Name -->
              <tr *ngIf="bankDetailsData.bank_name">
                <td class="email-table-label">Bank Name</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('bank_name', $event)"
                >
                  {{ bankDetailsData.bank_name }}
                </td>
              </tr>

              <!-- Branch Address -->
              <tr *ngIf="bankDetailsData.branch_address">
                <td class="email-table-label">Branch Address</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('branch_address', $event)"
                >
                  {{ bankDetailsData.branch_address }}
                </td>
              </tr>

              <!-- Account Number / IBAN -->
              <tr *ngIf="bankDetailsData.account_no">
                <td class="email-table-label">Account No</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('account_no', $event)"
                >
                  {{ bankDetailsData.account_no }}
                </td>
              </tr>

              <!-- IBAN Number (if separate) -->
              <tr *ngIf="bankDetailsData.iban_number && bankDetailsData.iban_number !== bankDetailsData.account_no">
                <td class="email-table-label">IBAN Number</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('iban_number', $event)"
                >
                  {{ bankDetailsData.iban_number }}
                </td>
              </tr>

              <!-- Correspondent Account Number -->
              <tr *ngIf="bankDetailsData.correspondent_account_number">
                <td class="email-table-label">Correspondent Acc No</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('correspondent_account_number', $event)"
                >
                  {{ bankDetailsData.correspondent_account_number }}
                </td>
              </tr>

              <!-- Swift Code -->
              <tr *ngIf="bankDetailsData.swift_code">
                <td class="email-table-label">Swift Code</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('swift_code', $event)"
                >
                  {{ bankDetailsData.swift_code }}
                </td>
              </tr>

              <!-- IFSC Code -->
              <tr *ngIf="bankDetailsData.ifsc_code">
                <td class="email-table-label">IFSC Code</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('ifsc_code', $event)"
                >
                  {{ bankDetailsData.ifsc_code }}
                </td>
              </tr>

              <!-- BIK / BIC Code -->
              <tr *ngIf="bankDetailsData.bik_code || bankDetailsData.bic_code">
                <td class="email-table-label">BIK / BIC Code</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('bik_code', $event)"
                >
                  {{ bankDetailsData.bik_code || bankDetailsData.bic_code }}
                </td>
              </tr>

              <!-- INN Code -->
              <tr *ngIf="bankDetailsData.inn_code">
                <td class="email-table-label">INN Code</td>
                <td
                  contenteditable="true"
                  class="email-table-value"
                  (blur)="updateBankDetail('inn_code', $event)"
                >
                  {{ bankDetailsData.inn_code }}
                </td>
              </tr>
            </ng-container>
          </table>
          <div
            contenteditable="true"
            class="email-content-editor-bottom"
            placeholder="Enter text below table..."
            #bottomTextDiv
            [innerHTML]="bottomTextContent"
          ></div>
        </div>
      </div>
    </div>
    <div class="signature-field-container">
      <div class="signature-field-label">
        <mat-label>Signature:</mat-label>
      </div>
      <div class="signature-field-input">
        <div class="signature-error-field">
          <mat-form-field appearance="outline" class="signature-input-field">
            <textarea
              matInput
              placeholder="Enter Signature"
              [formControl]="signature"
              class="signature-input"
            ></textarea>
          </mat-form-field>
          <div class="checkbox-container">
            <mat-checkbox [formControl]="update_signature"
              >Update Signature</mat-checkbox
            >
          </div>
        </div>
      </div>
    </div>
    <!-- ATTACHMENTS -->
    <div class="attachment-section">
      <div class="attachment-label">
        <mat-label>Attachments:</mat-label>
      </div>

      <div class="attachment-files">
        <!-- DB Files List (Displays all 4 files returned by API) -->
        <div class="attachment-file" *ngFor="let file of dbAttachments">
          <mat-icon>picture_as_pdf</mat-icon>
          <a [href]="file.url" target="_blank" rel="noopener noreferrer">
            {{ file.name }}
          </a>
        </div>

        <!-- PDA / FDA Report PDF -->
        <div class="attachment-file" *ngIf="reportPdfUrl">
          <mat-icon>picture_as_pdf</mat-icon>
          <a [href]="reportPdfUrl" target="_blank" rel="noopener noreferrer">
            {{ reportPdfName }}
          </a>
        </div>

        <!-- Loading state -->
        <div class="attachment-loading" *ngIf="isLoadingAttachments || isReportLoading">
          Loading attachments...
        </div>
      </div>
    </div>
    <div class="button-section">
      <button mat-flat-button class="cancel-button" (click)="closeDialog()">
        Cancel
      </button>
      <button
        mat-flat-button
        class="continue-button"
        [disabled]="selectedToEmails.length === 0"
        (click)="onContinue()"
      >
        Send
      </button>
    </div>
  </div>
</div>